import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { get, size } from 'lodash'
import QueryManager from './Query'

const GET_ORDER_COMMENTS = gql`
  # Write your query or mutation here
  
  query getCommentsbyOrderId($orderId: String) {
    getCommentsbyOrderId(orderId: $orderId) {
      count
      page
      pageSize
      results {
        ... on Comment {
          idOrder
          comment
          user
          phone
          contactType
          createdAt
          dataSource
        }
      }
    }
  }
`

const GetCommentsbyOrderId = ({ children, ...props }) => {
  return (
    <QueryManager query={GET_ORDER_COMMENTS} {...props}>
      {({ data, loading, fetchMore, refetch }) =>
        children({
          data: get(data, 'getCommentsbyOrderId.results', []),
          count: size(get(data, 'getCommentsbyOrderId.count')),
          refetch,
          loading
        })}
    </QueryManager>
  )
}

GetCommentsbyOrderId.propTypes = {
  children: PropTypes.any
}

export default GetCommentsbyOrderId
